import { defineModule } from '../../manifest.js';
export const manifest = defineModule({
    moduleKey: 'lms',
    name: 'LMS',
    description: 'Courses, enrolment, competence and training records.',
    kind: 'commercial',
    sellable: true,
    navigationModuleKey: 'lms',
    features: [{ key: 'lms.certification', description: 'Certification tracking with expiry' }],
    editions: [
        { code: 'ed_01', description: 'Base edition', features: [], limits: ['user'] },
        {
            code: 'ed_02',
            description: 'Adds certification tracking',
            features: ['lms.certification'],
            limits: ['user', 'active_user'],
        },
    ],
    limitTypes: ['user', 'active_user'],
    meteredEvents: [
    // Declared empty deliberately. This module is REGISTERED, not implemented:
    // what it meters is a decision that belongs to the stage that builds it,
    // and inventing metric keys now would put names into entitlement and
    // billing records before anybody designed them (S4-6).
    ],
    requiredCore: [
        'tenancy',
        'hierarchy',
        'identity',
        'authz',
        'audit',
        'storage',
        'party_master',
        'compliance_kernel',
    ],
    optionalModules: ['hr', 'field-service'],
    integrationDeps: [],
    lifecycle: 'proposed',
    commercialRelease: 'later',
    version: 1,
});
//# sourceMappingURL=module.manifest.js.map